import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { PrintFlagsLayout } from '../Layout';
import { NumberBox } from 'devextreme-react';

function TotalsTab(props) {
    
    var currentUser = props.oidc.user;

    const fieldRef = (el) => {
        if (el) {
            if(props.formRefs)
            props.formRefs.current['DISCOUNTPERCENTTOTALTAB'] = el;
        }
    };

    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    return (
        <div style={{ marginTop: "10px" }}>
            <div id="kanban">
                <div className='row' style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <div style={{ flexBasis: '97%' }}>
                        <div className="flex-container">
                            <fieldset className='list col-md-4 group-col col-fieldset'>
                                <legend className="list-title">Rate</legend>
                                <div className="field-container">
                                    <NumberBox
                                        style={{ pointerEvents: "auto", opacity: 1 }}
                                        value={0.00}
                                        label="Item Total"
                                        labelMode='static'
                                        stylingMode='outlined'
                                        format="$#,###0.00"
                                        readOnly={true}
                                        >
                                    </NumberBox>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            ref={fieldRef}
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.formFields['DISCOUNTPERCENT']}
                                            label="Total Discount"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="#,###0.00"
                                            onValueChanged={(e) => {

                                               props.setformFields(prevState => ({
                                                    ...prevState,
                                                    ['DISCOUNTPERCENT']: e.value,
                                                }));

                                                props.handleFieldChange('DISCOUNTPERCENT', e.value, e);
                                            }}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.taxRate}
                                            label="Sales Tax"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={0.00}
                                            label="Freight"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={0.00}
                                            label="Total Amount"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={0.00}
                                            label="Payments"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={0.00}
                                            label="Blanace Due"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.arTermsDiscountPercent}
                                            label="AR Terms Discount"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <legend className="list-title" style={{ marginTop: 10, marginBottom: 10 }}>Miscellaneous</legend>
                                <div className="field-container">
                                    <NumberBox
                                        style={{ pointerEvents: "auto", opacity: 1 }}
                                        value={0.00}
                                        label="Fees Added"
                                        labelMode='static'
                                        stylingMode='outlined'
                                        format="$#,###0.00"
                                        readOnly={true}
                                        >
                                    </NumberBox>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={0.00}
                                            label="Fees Included"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset className='list col-md-4 group-col col-fieldset'>
                                <legend className="list-title">Basis</legend>
                                    <div className="field-container">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={0.00}
                                            label="Item Total"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="#,###0.00"
                                            readOnly={true}
                                            >
                                        </NumberBox>
                                    </div>
                                    <div className="field-container">
                                        <div className="form-fields">
                                            <NumberBox
                                                style={{ pointerEvents: "auto", opacity: 1 }}
                                                value={props.selectedTotals?.discountableDetailAmount}
                                                label="Total Discount"
                                                labelMode='static'
                                                stylingMode='outlined'
                                                format="#,###0.00"
                                                readOnly={true}
                                            >
                                            </NumberBox>
                                        </div>
                                    </div>
                                    <div className="field-container">
                                        <div className="form-fields">
                                            <NumberBox
                                                style={{ pointerEvents: "auto", opacity: 1 }}
                                                value={props.selectedTotals?.taxed_1}
                                                label="Sales Tax"
                                                labelMode='static'
                                                stylingMode='outlined'
                                                format="#,###0.00"
                                                readOnly={true}
                                            >
                                            </NumberBox>
                                        </div>
                                    </div>
                                    <div className="field-container">
                                        <div className="form-fields">
                                            <NumberBox
                                                style={{ pointerEvents: "auto", opacity: 1 }}
                                                value={0.00}
                                                label="Freight"
                                                labelMode='static'
                                                stylingMode='outlined'
                                                format="#,###0.00"
                                                readOnly={true}
                                            >
                                            </NumberBox>
                                        </div>
                                    </div>
                                    <div className="field-container">
                                        <div className="form-fields">
                                            <NumberBox
                                                style={{ pointerEvents: "auto", opacity: 1 }}
                                                value={0.00}
                                                label="Total Amount"
                                                labelMode='static'
                                                stylingMode='outlined'
                                                format="#,###0.00"
                                                readOnly={true}
                                            >
                                            </NumberBox>
                                        </div>
                                    </div>
                                    <div className="field-container">
                                        <div className="form-fields">
                                            <NumberBox
                                                style={{ pointerEvents: "auto", opacity: 1 }}
                                                value={0.00}
                                                label="Payments"
                                                labelMode='static'
                                                stylingMode='outlined'
                                                format="#,###0.00"
                                                readOnly={true}
                                            >
                                            </NumberBox>
                                        </div>
                                    </div>
                                    <div className="field-container">
                                        <div className="form-fields">
                                            <NumberBox
                                                style={{ pointerEvents: "auto", opacity: 1 }}
                                                value={0.00}
                                                label="Blanace Due"
                                                labelMode='static'
                                                stylingMode='outlined'
                                                format="#,###0.00"
                                                readOnly={true}
                                            >
                                            </NumberBox>
                                        </div>
                                    </div>
                                    <div className="field-container">
                                        <div className="form-fields">
                                            <NumberBox
                                                style={{ pointerEvents: "auto", opacity: 1 }}
                                                value={props.selectedTotals?.arTermsDiscountBasis}
                                                label="AR Terms Discount"
                                                labelMode='static'
                                                stylingMode='outlined'
                                                format="#,###0.00"
                                                readOnly={true}
                                            >
                                            </NumberBox>
                                        </div>
                                    </div>
                                    <legend className="list-title" style={{ marginTop: 10, marginBottom: 10 }}>Miscellaneous</legend>
                                    <div className="field-container">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={0.00}
                                            label="Fees Added"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="#,###0.00"
                                            readOnly={true}
                                            >
                                        </NumberBox>
                                    </div>
                                    <div className="field-container">
                                        <div className="form-fields">
                                            <NumberBox
                                                style={{ pointerEvents: "auto", opacity: 1 }}
                                                value={0.00}
                                                label="Fees Included"
                                                labelMode='static'
                                                stylingMode='outlined'
                                                format="#,###0.00"
                                                readOnly={true}
                                            >
                                            </NumberBox>
                                        </div>
                                    </div>
                            </fieldset>
                            <fieldset className='list col-md-4 group-col col-fieldset'>
                                <legend className="list-title">Amount</legend>
                                <div className="field-container">
                                    <NumberBox
                                        style={{ pointerEvents: "auto", opacity: 1 }}
                                        value={props.selectedTotals?.itemTotal}
                                        label="Item Total"
                                        labelMode='static'
                                        stylingMode='outlined'
                                        format="$#,###0.00"
                                        readOnly={true}
                                        >
                                    </NumberBox>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.orderDiscountAmount}
                                            label="Total Discount"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.totalTax}
                                            label="Sales Tax"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.totalFreightAmount}
                                            label="Freight"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.totalAmount}
                                            label="Total Amount"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.outARPayments}
                                            label="Payments"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.outARBalanceDue}
                                            label="Blanace Due"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.arTermsDiscountAmount}
                                            label="AR Terms Discount"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                                <legend className="list-title" style={{ marginTop: 10, marginBottom: 10 }}>Miscellaneous</legend>
                                <div className="field-container">
                                    <NumberBox
                                        style={{ pointerEvents: "auto", opacity: 1 }}
                                        value={props.selectedTotals?.totalFeesAdded}
                                        label="Fees Added"
                                        labelMode='static'
                                        stylingMode='outlined'
                                        format="$#,###0.00"
                                        readOnly={true}
                                        >
                                    </NumberBox>
                                </div>
                                 <div className="field-container">
                                    <div className="form-fields">
                                        <NumberBox
                                            style={{ pointerEvents: "auto", opacity: 1 }}
                                            value={props.selectedTotals?.totalFeesIncluded}
                                            label="Fees Included"
                                            labelMode='static'
                                            stylingMode='outlined'
                                            format="$#,###0.00"
                                            readOnly={true}
                                        >
                                        </NumberBox>
                                    </div>
                                </div>
                            </fieldset>
                            <div>
                               <FormField
                                    hasOnlyOneColumn={true}
                                    currrentUser={currentUser}
                                    layoutId='1ec9fac0-1863-4de5-a5fb-22fbd6950429'
                                    layoutName='OMSalesOrderDataEntryTotalsForm'
                                    defaultFormSchema={PrintFlagsLayout}
                                    formFields={props.formFields}
                                    setformFields={props.setformFields}
                                    handleFieldValueChange={props.handleFieldChange}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={props.formRefs}
                                    onFormLoad={props.onFormLoad}
                                    handleSelectedItemChange={props.handleSelectionChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Form Field Component 
                
            */}
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TotalsTab);
